<!-- <p-dialog
  header="Audit Log "
  [appendTo]="'body'"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [dismissableMask]="true"
  [closable]="true"
  (onHide)="onClose()"
>
  <div class="audit-log-container">
    <div class="audit-item" *ngFor="let log of logs; let i = index">
      <div class="audit-bullet"></div>

      <div class="audit-line" *ngIf="i < logs.length - 1"></div>

      <div class="audit-content">
        <div class="audit-meta">
          <span class="date">{{ log.date }}</span> |
          <span class="time">{{ log.time }}</span>
        </div>
        <div class="audit-action">
          <strong>{{ log.user }}</strong> {{ log.action }}
        </div>
      </div>
    </div>
  </div>
</p-dialog> -->

<!-- TEST -->

<p-dialog
  header="Audit Log:"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '50vw' }"
  [dismissableMask]="dismissableMask"
  [closable]="true"
  (onHide)="onClose()"
>
  <!-- Debug Info -->
  <!-- <div style="position: absolute; top: 10px; right: 10px; background: yellow; padding: 5px; font-size: 12px; z-index: 1000;">
    Loading: {{ loading }} | Logs: {{ logs?.length || 0 }}
  </div> -->

  @if (loading) {
  <!-- Loading State -->
  <div class="flex items-center justify-center min-h-[300px]">
    <app-loader
      type="inline"
      message="Loading audit logs..."
      size="medium"
      ariaLabel="Loading audit logs"
    >
    </app-loader>
  </div>
  } @else {
  <!-- Content State -->
  <div class="audit-log-container">
    @if (logs && logs.length > 0) { @for (log of logs; track log.date; let i =
    $index) {
    <div class="audit-item">
      <div class="audit-bullet">•</div>

      @if (i < logs.length - 1) {
      <div class="audit-line"></div>
      }

      <div class="audit-content">
        <div class="audit-meta">
          <span class="date">{{ log.date }}</span> |
          <span class="time">{{ log.time }}</span>
        </div>
        <div class="audit-action">
          <strong>{{ log.user }}</strong> {{ log.action }}
        </div>
      </div>
    </div>
     } } @else {
     <div class="flex items-center justify-center min-h-[200px]">
       <app-loader 
         type="inline" 
         message="Loading..." 
         size="medium"
         ariaLabel="Loading">
       </app-loader>
     </div>
     }
  </div>
  }
</p-dialog>
